import { Confirm } from '../Confirm.page';
import { CONFIRMATION_TYPE } from '../hooks/useConfirmation.decl';

export default function ConfirmUserCreation() {
  return <Confirm type={CONFIRMATION_TYPE.USER} data-test='confirm-user-creation-page' />;
}
